import React from 'react'
import { Box } from '@mui/material'
import RouletteWheelIcon from '../Brewlette/RouletteWheelIcon'
import styles from './SelectionActionBar.module.css'

interface BrewletteOnlyBarProps {
  onBrewletteClick: () => void
}

export const BrewletteOnlyBar = React.forwardRef<HTMLDivElement, BrewletteOnlyBarProps>(({ onBrewletteClick }, ref) => {
  return (
    <Box ref={ref} className={`${styles.brewletteOnly} ${styles.actionBarCompact}`}>
      <Box className={`${styles.actions} ${styles.actionsThree} ${styles.brewletteOnlyActions} ${styles.actionsCompact}`}>
        <button
          onClick={onBrewletteClick}
          className={`${styles.actionButton} ${styles.brewletteActionButton} ${styles.actionButtonCompact}`}
          aria-label="Open Brewlette"
          data-tour="brewlette-button"
        >
          <RouletteWheelIcon size={24} />
          <span className={styles.actionText}>Brewlette</span>
        </button>
      </Box>
    </Box>
  )
})
